import Vue from 'vue';
import VueCustomElement from 'vue-custom-element';
import HotelDetailBookmarkHeart from "BookmarkHotelList/HotelDetailBookmarkHeart.vue";
var initializeHotelDetailBookmarkHeart = function () {
    Vue.use(VueCustomElement);
    // @ts-ignore
    Vue.customElement('c-hotel-detail-bookmark-heart', new HotelDetailBookmarkHeart().$options);
};
export default initializeHotelDetailBookmarkHeart;
